import React, { useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { images } from "../../constants";

import { AppWrap, MotionWrap } from "../../wrapper";
// import { urlFor, client } from '../../client';
import "./Testimonial.scss";

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [
    {
      _type: "testimonials",
      company: "Prathamesh Tailors",
      feedback:
        "He is a good sign board maker near me, created a nice board for my tailer shop.",
      imgurl: images.customer01,
      name: "Prathamesh Kirti",
    },
    {
      _type: "testimonials",
      company: "Rahul Ahuja",
      feedback:
        "Great quality, value for money, created a very nice and good-looking sign board for our business. Best hand painter and sign board painter near me.",
      imgurl: images.dummy_customer,
      name: "Business Man",
    },
    {
      _type: "testimonials",
      company: "Archana Belose",
      feedback:
        "One of the best sign board painters near me. Great work, board delivered on time and everything done as required.",
      imgurl: images.dummy_customer,
      name: "Content Creater",
    },
  ];

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  // useEffect(() => {
  //   const query = '*[_type == "testimonials"]';

  //   client.fetch(query).then((data) => {
  //     setTestimonials(data);
  //   });
  // }, []);

  return (
    <>
      {testimonials.length && (
        <>
          <h2 className="head-text ">
            My <span>Testimonials</span>
          </h2>
          <br />
          <div className="app__testimonial-item app__flex">
            <img
              src={testimonials[currentIndex].imgurl}
              alt={testimonials[currentIndex].name}
            />
            <div className="app__testimonial-content">
              <p className="p-text">{testimonials[currentIndex].feedback}</p>
              <div>
                <h4 className="bold-text">{testimonials[currentIndex].name}</h4>
                <h5 className="p-text">{testimonials[currentIndex].company}</h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div
              className="app__flex"
              onClick={() =>
                handleClick(
                  currentIndex === 0
                    ? testimonials.length - 1
                    : currentIndex - 1
                )
              }
            >
              <HiChevronLeft />
            </div>

            <div
              className="app__flex"
              onClick={() =>
                handleClick(
                  currentIndex === testimonials.length - 1
                    ? 0
                    : currentIndex + 1
                )
              }
            >
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      {/* <div className="app__testimonial-brands app__flex">
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={brand._id}
          >
            <img src={urlFor(brand.imgUrl)} alt={brand.name} />
          </motion.div>
        ))}
      </div> */}
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "testimonial",
  "app__whitebg"
);
